/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* preference-service.ts  2023-10-30T16:25:38+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';


const _ = 'Preference/';

export class PreferenceService {

  constructor(readonly r: RpcService) {}
  // 不喜欢某个视频
  dislike(d:string, m?: M): R<boolean>{
    return this.r.async(_ + 'dislike', d, m);
  }
}
